/* @flow */

import Cookies from 'js-cookie';
import { compose } from 'ramda';
import { connect } from 'react-redux';
import { getEventLanguages } from '@e180/domain/lib/event/util';

import PreferenceLanguageSectionDumb from './PreferenceLanguageSectionDumb';
import { isDevModeEnabled } from 'src/shared/app/base/selector/appEnvSelectors';
import { localeCookieParam } from 'src/shared/app/base/route/setting/cookieSettings';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';
import { patchSelf } from 'src/shared/domain/user/action/userActions';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';

const mapStateToProps = (state: Object): Object => {
  const event = getEventSafely(state);
  const user = getSelf(state);

  return {
    eventLocales: getEventLanguages(event),
    // Used in `mergeProps` only
    isDevModeEnabled: isDevModeEnabled(state),
    user,
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => {
  const { isDevModeEnabled } = stateProps;
  const { user } = stateProps;

  const setCookie = (locale) => {
    Cookies.set(localeCookieParam, locale, {
      expires: 365,
      path: '/',
      secure: !isDevModeEnabled,
    });

    // Reload page without query params
    window.location.replace(location.pathname);
  };

  return {
    ...stateProps,
    handleChange(locale: string) {
      if (user) {
        dispatch(patchSelf({ language: locale }))
          .then(() => {
            setCookie(locale);
          })
          .catch((e) => {
            console.error(e);
          });
      } else setCookie(locale);
    },
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(PreferenceLanguageSectionDumb);
